import Dashboard from '../components/Contents/Main/Dashboard.vue'
import Individual from '../components/Contents/Main/Individual.vue'
import Preferences from '../components/Contents/Main/Preferences.vue'
import Reminders from '../components/Contents/Main/Reminders.vue'
import CustomersList from '../components/Contents/Main/CustomersList.vue'
import Customers from '../components/Contents/Main/Customers.vue'

export default {
  routes () {
    return [
      {
        path: '',
        component: Dashboard
      },
      {
        path: '/individual',
        component: Individual
      },
      {
        path: '/customers',
        component: CustomersList
      },
      {
        path: '/customers/:id',
        name: 'customer',
        component: Customers
      },
      {
        path: '/preferences',
        component: Preferences
      },
      {
        path: '/reminders',
        component: Reminders
      }
    ]
  }
}




// WEBPACK FOOTER //
// ./src/router/index.js